import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';
import { browserHistory } from '../../../utilities/history';
import LoginForm from './LoginForm';
import LoadingOverlay from '../../common/LoadingOverlay';
import { logIn } from '../../../api/Auth';
import { setTokens } from '../../../utilities/identity';
import StandardLayout from '../../layouts/StandardLayout';

interface State {
    errorMessage?: string;
    isLoading: boolean;
}

interface Props extends RouteComponentProps<{}> {}

class LogInPage extends React.Component<Props, State> {
    redirectPath: string = '/';
    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: false
        };

        if (
            this.props.history &&
            this.props.history.location &&
            this.props.history.location.state &&
            this.props.history.location.state.from
        ) {
            // Extract the redirect path from the current location's state
            this.redirectPath = (this.props.history.location.state.from as Location).pathname;
        }

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    render() {
        return (
            <StandardLayout>
                <LoadingOverlay show={this.state.isLoading} inBootstrapColumn={true} />
                <LoginForm errorMessage={this.state.errorMessage} onSubmit={this.handleSubmit} />
            </StandardLayout>
        );
    }

    private async handleSubmit(username: string, password: string) {
        this.setState({
            isLoading: true
        });

        let loginResult = await logIn(username, password);

        if (loginResult.success && loginResult.data) {
            setTokens(loginResult.data.jwt, loginResult.data.refreshToken);
            browserHistory.push(this.redirectPath);
            return true;
        } else {
            this.setState({
                isLoading: false,
                errorMessage: loginResult.error
            });
            return false;
        }
    }
}

export default withRouter<Props>(LogInPage);



// WEBPACK FOOTER //
// ./src/components/pages/auth/LogInPage.tsx